<template>
  <div class="container px-0">
    <div class="row justify-content-center">
      <div v-for="(field, idx) in steps" :key="idx"
        class="card-wrapper"
      >
        <div class="image-wrapper" :style="`background-color: ${colorSchema};`">
          <img :src="field.image.src" :alt="field.image.alt">
        </div>
        <div class="card" :style="`background-color: ${colorSchema2};`">
          <span class="step-number">{{ idx + 1 }}</span>
          <span class="step-text">{{ $t(field.text) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'landing-steps',
  props: {
    grid: {
      type: Object,
      required: true
    },
    steps: {
      type: Array,
      required: true
    },
    colorSchema: {
      type: String
    },
    colorSchema2: {
      type: String
    },
    numberStyles: {
      type: Object
    },
    textStyles: {
      type: Object
    },
    stepStyles: {
      type: Object
    },
    styles: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
  .landing-steps {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 767px) {
      flex-direction: column;
      margin-bottom: 20px;
    }
  }

  .card-wrapper {
    display: grid;
    grid-template-columns: 1fr 3fr;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 800px;
    padding: 20px;
    border: none;
    .image-wrapper {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 64px;
        max-height: 64px;
      }
    }
    .card {
      border: none;
      border-radius: 0;
      height: 100%;
      display: flex;
      flex-direction: row;
      padding: 20px;
      justify-content: space-between;
      align-items: center;
      .step-number {
        color: var(--text-color-1);
        font-size: 34px;
        line-height: 61px;
        font-weight: 500;
        margin: 10px;
      }

      .step-text {
        color: var(--text-color-1);
        text-align: center;
        flex-grow: 1;
        text-align: left;
        font-weight: 300;
      }
    }
  }


</style>